/**
 * Gets the closest ancestor of the element (or the element itself) using a query selector.
 *
 * @param element Starting element.
 * @param query Query to locate.
 * @returns {Element}
 */
export function closest(element: Element, query: string): Element {
    if (element && element.closest) {
        return element.closest(query);
    }

    // for IE11 and below
    while (element && !(element.matches || (element as any).msMatchesSelector).call(element, query)) {
        element = element.parentElement;
    }

    return element;
}
